import { useContext } from "react";

import { useRouter } from "next/router";
import useSWR from "swr";

import { Menu, Status } from "~components";
import { Detail } from "~components/events";
import { BaseContext } from "~context";
import { Event, getEvent, getRelease, Release } from "~graphql/fetchers";
import { useCampaignReportingOpen } from "~hooks/useBroadastCampaignReporting";
import { Detail as DetailV2 } from "~features/events/components/EventDetails/EventDetails";
import { useOrganization } from "~hooks";

type QueryParams = {
  eventId?: string;
  release?: string;
  slug?: string;
};

const EventInfoPage = () => {
  const router = useRouter();
  const query = router.query as QueryParams;
  const { organization } = useContext(BaseContext);
  const { hasFeature } = useOrganization();

  const { error: eventError, data: event } = useSWR<Event, Error>(
    ["event", organization.id, router.query.eventId],
    getEvent
  );

  const { data: release, error: releaseError } = useSWR<Release, Error>(
    ["release", organization?.id, query.eventId, query.release, query.slug],
    getRelease
  );

  const isLoading = (!event && !eventError) || (!release && !releaseError);
  useCampaignReportingOpen(!isLoading);

  const useDetailsV2 = hasFeature("eventDetailsV2");

  return (
    <>
      <Menu />
      <Status loading={isLoading} error={eventError}>
        {/* Existing details page */}
        {!isLoading && !useDetailsV2 ? (
          <Detail
            event={event}
            releaseIsActive={releaseError ? false : release?.isActive}
          />
        ) : null}

        {/* New details page */}
        {!isLoading && useDetailsV2 ? (
          <DetailV2 event={event} release={release} />
        ) : null}
      </Status>
    </>
  );
};

export default EventInfoPage;
